module.exports = __webpack_public_path__ + "assets/img/index-product3.79f482fe.png";